module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs hide-small"
  }, [_c('div', {
    class: [_vm.tab === 'main' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.tab = 'main'
      }
    }
  }, [_vm._v("Main details")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs tabs-right hide-small"
  }, [_c('div', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-tab'],
    on: {
      "click": function($event) {
        return _vm.save(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate))]), _vm._v(" "), _c('div', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-tab'],
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate) + " & exit")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown show-small dropdown-admin-tabs"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.tab = 'main'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n          Main details\n          "), (_vm.tab === 'main') ? _c('i', {
    staticClass: "fa fa-check-square-o"
  }) : _vm._e()])]), _vm._v(" "), _c('li', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-dropdown'],
    on: {
      "click": function($event) {
        return _vm.save(false)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate))])]), _vm._v(" "), _c('li', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-dropdown'],
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate) + " & exit")])])])]), _vm._v(" "), _c('section', {
    staticClass: "clearfix",
    attrs: {
      "id": "main-content"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "admin-content",
      "id": "location-content"
    },
    slot: "admin-content"
  }, [(_vm.entity.id) ? _c('h4', [_vm._v("Editing " + _vm._s(_vm.entity.name) + " Spreadsheet")]) : _vm._e(), _vm._v(" "), (_vm.tab === 'main') ? _c('div', [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "admin-content",
      "id": "location-content"
    },
    slot: "admin-content"
  }, [(_vm.entity.id) ? _c('div', {
    staticClass: "col-xs-12 gap"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "shadow platform"
  }, [_c('div', {
    staticClass: "inner-tab-outer"
  }, [_c('span', {
    class: [_vm.visible === 'spreadsheet' ? 'vis' : ''],
    staticStyle: {
      "border-right": "none"
    },
    on: {
      "click": function($event) {
        _vm.visible = 'spreadsheet'
      }
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('span', {
    class: [_vm.visible === 'details' ? 'vis' : ''],
    on: {
      "click": function($event) {
        _vm.visible = 'details'
      }
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-tab-outer"
  }, [_c('span', {
    class: [_vm.visible === 'tariff' ? 'vis' : ''],
    staticStyle: {
      "border-top": "none"
    },
    on: {
      "click": function($event) {
        _vm.visible = 'tariff'
      }
    }
  }, [_vm._v("Tariffs")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible === 'spreadsheet'),
      expression: "visible === 'spreadsheet'"
    }]
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 main-location-details left top-small"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sd-name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sd-name"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sd-date-format"
    }
  }, [_vm._v("Date Format")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.dateFormat),
      expression: "entity.dateFormat"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sd-date-format"
    },
    domProps: {
      "value": (_vm.entity.dateFormat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "dateFormat", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.entity.id),
      expression: "entity.id"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "file"
    }
  }, [_vm._v("Upload Tariff")]), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": function($event) {
        return _vm.handleFileUpload()
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.file),
      expression: "file"
    }],
    staticClass: "btn btn-primary sq",
    attrs: {
      "disabled": _vm.uploading
    },
    on: {
      "click": function($event) {
        return _vm.upload()
      }
    }
  }, [_vm._v("Upload")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 main-location-details left bottom-small"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sd-email"
    }
  }, [_vm._v("Notification Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.notificationEmail),
      expression: "entity.notificationEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sd-email"
    },
    domProps: {
      "value": (_vm.entity.notificationEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "notificationEmail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sd-spreadsheet-type"
    }
  }, [_vm._v("Spreadsheet Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.spreadsheetType),
      expression: "entity.spreadsheetType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "sd-spreadsheet-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "spreadsheetType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('SPREADSHEET_TYPE')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sd-email"
    }
  }, [_vm._v("Allow Old Tariff End Date Update?")]), _vm._v(" "), _c('div', {
    staticClass: "material-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.allowOldTariffEndDateUpdate),
      expression: "entity.allowOldTariffEndDateUpdate"
    }],
    attrs: {
      "id": "maritime",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.allowOldTariffEndDateUpdate) ? _vm._i(_vm.entity.allowOldTariffEndDateUpdate, null) > -1 : (_vm.entity.allowOldTariffEndDateUpdate)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.allowOldTariffEndDateUpdate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "allowOldTariffEndDateUpdate", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "allowOldTariffEndDateUpdate", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "allowOldTariffEndDateUpdate", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-success",
    attrs: {
      "for": "maritime"
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible === 'details'),
      expression: "visible === 'details'"
    }]
  }, [_c('div', {
    staticClass: "clearfix bg-wht col-xs-12"
  }, [_c('basic-details', {
    attrs: {
      "dets": _vm.basicDetails,
      "parent": _vm.entity.id,
      "properties": this.properties,
      "type": "main"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible === 'tariff'),
      expression: "visible === 'tariff'"
    }]
  }, [_c('div', {
    staticClass: "clearfix bg-wht col-xs-12"
  }, [_c('tariff-details', {
    attrs: {
      "dets": _vm.tariffs,
      "parent": _vm.entity.id,
      "getForParent": _vm.getForParent,
      "visible": _vm.visible === 'tariff'
    }
  })], 1)])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Options\n      "), _c('span', {
    staticClass: "caret"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81d6f79a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/SpreadsheetDescriptor/SpreadsheetDescriptor.vue
// module id = 2246
// module chunks = 1